export{VDSManager,calculateRem,withVDSManager}from"@vds-core/utilities";
